import React, { useEffect } from "react";
import ReusableModal from "../../../../components/Modals/ReusableModal";
import Select from "react-select";
import { useUpdateProviderMissingFieldsMutation } from "../../../../features/provider/providerApiSlice";
// import { STATES } from "../../../../constants/config.constants";

const ProviderPersonalInfoModal = ({
  open,
  setOpen,
  provider,
  setProvider,
  marketId,
}) => {
  const genderOptions = [
    { value: "M", label: "Male" },
    { value: "F", label: "Female" },
    // { value: "O", label: "Other" },
  ];

  const [providerStreet, setProviderStreet] = React.useState("");
  const [providerCity, setProviderCity] = React.useState("");
  const [providerState, setProviderState] = React.useState("");
  const [providerZip, setProviderZip] = React.useState("");
  const [providerGender, setProviderGender] = React.useState(
    provider.gender
      ? genderOptions.find((option) => option.value === provider.gender)
      : genderOptions[2]
  );
  const [errorMsg, setErrorMsg] = React.useState("");

  const [updateProviderMissingFields, { isLoading: missingLoading }] =
    useUpdateProviderMissingFieldsMutation();

  const handleSubmit = async () => {
    try {
      try {
        await updateProviderMissingFields({
          id: provider.id,
          data: {
            npi_id: provider.npiId,
            speciality: provider.speciality,
            street: providerStreet,
            city: providerCity,
            state: providerState,
            zip: providerZip,
            gender: providerGender.value,
            marketProfileId: marketId,
          },
        }).unwrap();

        await setProvider((prev) => ({
          ...prev,
          gender: providerGender.value,
          address: `${providerStreet},${providerCity},${providerState},${providerZip}`,
        }));
      } catch (error) {
        setErrorMsg(error.data.message);
      }
    } catch (error) {
      console.error("Failed to update provider information: ", error);
      setErrorMsg("Failed to update provider information");
    }
  };

  useEffect(() => {
    const [street, city, state, zip] = provider.address.split(",");

    setProviderStreet(street);
    setProviderCity(city);
    setProviderState(state);
    setProviderZip(zip);
  }, []);

  return (
    <ReusableModal
      open={open}
      title="Update Personal Information"
      onClose={() => {
        setOpen(false);
        setProviderStreet("");
        setProviderCity("");
        setProviderState("");
        setProviderZip("");
        setProviderGender(genderOptions[2]);
      }}
    >
      <div className="flex flex-col w-full gap-4 p-6 min-w-[500px]">
        <div className="flex flex-col w-full gap-2">
          <label htmlFor="email" className="m-0 text-base font-semibold">
            Gender
          </label>
          <Select
            options={genderOptions}
            placeholder="Select Gender"
            className="w-full"
            defaultValue={providerGender}
            onChange={(selectedOption) => {
              setProviderGender(selectedOption);
            }}
          />
        </div>
        <label
          htmlFor="street"
          className="text-base font-semibold border-b-[1px]"
        >
          Address
        </label>
        <div className="grid grid-cols-2 gap-6">
          <div className="flex flex-col w-full gap-2">
            <label htmlFor="street" className="m-0 text-base font-semibold">
              Street
            </label>
            <input
              type="text"
              id="street"
              name="street"
              placeholder="Enter Street"
              className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
              onChange={(e) =>
                setProviderStreet(e.target.value.replace(",", " "))
              }
              value={providerStreet}
            />
          </div>
          <div className="flex flex-col w-full gap-2">
            <label htmlFor="city" className="m-0 text-base font-semibold">
              City
            </label>
            <input
              type="text"
              id="city"
              name="city"
              placeholder="Enter City"
              className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
              onChange={(e) => setProviderCity(e.target.value)}
              value={providerCity}
            />
          </div>
          <div className="flex flex-col w-full gap-2">
            <label htmlFor="state" className="m-0 text-base font-semibold">
              State
            </label>
            {/* <select
              id="state"
              name="state"
              placeholder="Select State"
              className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
              value={providerState?.trim() || ""}
              onChange={(e) => setProviderState(e.target.value)}
            >
              <option value="" disabled hidden>
                Select State
              </option>
              {
                STATES.map((state) => (
                  <option key={state} value={state}>{state}</option>
                ))
              }
            </select> */}
            <input
              type="text"
              id="state"
              name="state"
              placeholder="Enter State"
              className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
              onChange={(e) => setProviderState(e.target.value)}
              value={providerState}
            />
          </div>
          <div className="flex flex-col w-full gap-2">
            <label htmlFor="zip" className="m-0 text-base font-semibold">
              Zip
            </label>
            <input
              type="text"
              id="zip"
              name="zip"
              placeholder="Enter Zip"
              className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
              onChange={(e) => setProviderZip(e.target.value)}
              value={providerZip}
            />
          </div>
        </div>
        {errorMsg && <div className="text-red-500">{errorMsg}</div>}
        <div className="flex flex-row items-center justify-between w-full gap-6">
          <button
            disabled={missingLoading}
            className="w-1/2 p-2 font-semibold rounded-md  border-[2px] text-primaryblue border-primaryblue"
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            disabled={
              providerStreet === "" ||
              providerCity === "" ||
              providerState === "" ||
              providerZip === ""
            }
            className="w-1/2 disabled:opacity-40 disabled:cursor-not-allowed font-semibold p-2 border-[2px] rounded-md bg-primaryblue border-primaryblue text-white whitespace-nowrap"
            onClick={async () => {
              await handleSubmit();
              setOpen(false);
            }}
          >
            Yes, Update
          </button>
        </div>
      </div>
    </ReusableModal>
  );
};

export default ProviderPersonalInfoModal;
